function InitBarba() {
	$('body').imagesLoaded({
		background: true
	}).always(function () {
		pageTransition.enter();
	});


	barba.init({
		prefetchIgnore: false,
		timeout: 10000,
		transitions: [{
			leave(data) {
				const done = this.async();
				pageTransition.leave(done);
			},
			enter({next}) {
				pageTransition.enter();
			},
		}],
		// Admin bar
		prevent: ({ el }) => el.classList && ( el.classList.contains('ab-item') || el.classList.contains('no-barba') )
	});

	barba.hooks.after((data) => {
		// Traitements à effectuer au chargement d’une nouvelle page par barba
		barbaCallbacks.forEach(function (callback) {
			try {
				if (typeof callback.destroy === 'function') {
					callback.destroy();
				}
				if (typeof callback.build === 'function') {
					callback.build();
				}
			} catch (e) {
				console.error(e);
			}
		});
	});

	barba.hooks.afterLeave((data) => {
		// Set <body> classes for "next" page
		var nextHtml = data.next.html;
		var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml);
		var bodyClasses = $(response).filter('notbody').attr('class');
		$("body").attr("class", bodyClasses);

		// Décommenter si le menu est en dehors du barba container
		/*const active = $(response).find('.current-menu-item');
		$('.current-menu-item').removeClass('current-menu-item');
		if (active && active.length) {
			for (const cssClass of active[0].classList) {
				if (cssClass.match(/^menu-item-\d+/)) {
					$('.' + cssClass).addClass('current-menu-item');
					break;
				}
			}
		}*/
	});
}
